import playlist from './PlaylistReducer';

// if there are more than one reducer in this component, use combineReducers
/*
import {combineReducers} from "redux";
import anyreducer from "./anyreducer";
const anyreducer = combineReducers({
    anyreducer
})
*/
export default playlist;
